import React from 'react'
import { Icon, Popover } from 'antd'
import VPlayer from 'components/VPlayer'
import { timeFormat } from 'util/utils'
import styles from './index.scss'

type Collect = {
  collectCount: number
  hasCollect: 0 | 1
}

type Praise = {
  count: number
  hasPraise: 0 | 1
}

export type TVType = 'm3u8' | 'audio' | 'video'
interface Props {
  src: string
  title: string
  time: number
  qrcode: string
  courseTime?: number
  tags?: any
  people?: number
  link?: string
  collect?: Collect
  praise?: Praise
  type?: string
  onLike?: React.EventHandler<any>
  onPlay?: () => any
  onCollect?: React.EventHandler<any>
}

export const types = [
  {
    key: '1000101',
    value: 'video',
  },
  {
    key: '1000102',
    value: 'article',
  },
  {
    key: '1000103',
    value: 'audio',
  },
  {
    key: '1000106',
    value: 'video',
  },
]

export const isSelfVideo = str => /^https?:\/{2}/.test(str)
export const sohufilter = _src => {
  const reg = /<embed(.*?)<\/embed>/
  if (reg.test(_src)) {
    return <div dangerouslySetInnerHTML={{ __html: _src.match(reg)[0] }} />
  }
  return <div dangerouslySetInnerHTML={{ __html: _src }} />
}

const VideoPanel = ({
  src,
  title,
  time,
  qrcode,
  courseTime = 0,
  tags,
  people = 0,
  link,
  collect,
  praise,
  onLike,
  onPlay,
  type,
  onCollect,
}: Props) => {
  const isCollect = Boolean(collect.hasCollect)
  const isPraise = Boolean(praise.hasPraise)

  function download(url) {
    if (!url) {
      return
    }
    return (window.location.href = url)
  }

  const collectBtn = (
    <div onClick={onCollect.bind(null)} className={styles.button}>
      <Icon
        type={isCollect ? 'star' : 'star-o'}
        style={{ color: isCollect && '#FF3C00', fontSize: 20 }}
      />
      <span>{isCollect ? '已收藏' : `${collect.collectCount}人收藏`}</span>
    </div>
  )

  const likeBtn = (
    <div onClick={onLike.bind(null)} className={styles.button}>
      <Icon
        type={isPraise ? 'like' : 'like-o'}
        style={{ color: isPraise && '#FF3C00', fontSize: 20 }}
      />
      <span>{`${praise.count || 0}人点赞`}</span>
    </div>
  )

  return (
    <div className={styles.container}>
      <div className={styles.panel}>
        <div className={styles.title}>
          <span>{title}</span>
          {qrcode && (
            <Popover
              content={<img src={qrcode} style={{ width: 150, height: 150 }} />}
              placement="bottomRight"
              arrowPointAtCenter
              title="用小程序观看课程"
            >
              <Icon
                type="qrcode"
                style={{
                  color: '#fb4634',
                  position: 'absolute',
                  right: 42,
                  top: 26,
                }}
              />
            </Popover>
          )}
        </div>
        <div className={styles.tags}>{tags}</div>
        <div className={styles.info}>
          <div className={styles.description}>
            <span>{timeFormat(time)}</span>
          </div>
          <div className={styles.description}>
            <span>{`${people > 9999 ? '9999+' : people}人学过`}</span>
            {/* <span>{`${people}人学过`}</span> */}
          </div>
          <div className={styles.description}>
            <span>{`时长：${
              !!courseTime ? `${courseTime} min` : '未知'
            }`}</span>
          </div>
          <div
            className={styles.button}
            style={{
              opacity: !link && 0.5,
              cursor: !link && 'no-drop',
              color: link && '#FF3C00',
            }}
            onClick={download.bind(null, link)}
          >
            <Icon style={{ fontSize: 20 }} type="download" />
            <span>下载课件</span>
          </div>
          {collectBtn}
          {likeBtn}
        </div>
        {isSelfVideo(src) ? (
          <VPlayer
            type={types.filter(v => v.key === type)[0].value as TVType}
            src={src}
            onplay={onPlay}
          />
        ) : (
          sohufilter(src)
        )}
      </div>
    </div>
  )
}

export default VideoPanel
